import { useState, useEffect } from 'react';
import type { ReactNode } from 'react';

import { getDumbyData } from './utils';

type Data = Awaited<ReturnType<typeof getDumbyData>>;

interface Props {
  rowCount: number;
  children: ({ data }: { data: Data }) => ReactNode;
}

export const WithDummyData = ({ rowCount, children }: Props) => {
  const [data, setData] = useState<Data | null>(null);

  useEffect(() => {
    if (data !== null) return;
    async function asyncData() {
      const data = await getDumbyData(rowCount);
      setData(data);
    }
    asyncData();
  }, []);

  if (data === null || !children) return null;

  return children({ data });
};
